import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import ICheckList from 'Models/docas/Checklist'
import ApiService from 'Services/ApiService'
import { ServiceListResponse } from 'Types/ServiceResponse'

const checklist = {
  getList: async (idComponente: number, cdEmpresa: number) => {
    const result: AxiosResponse<ServiceListResponse<ICheckList[]>> =
      await ApiService({ idComponente }).get<ServiceListResponse<ICheckList[]>>(
        `${hosts.WS_DOCAS}/checklist_empresa/${cdEmpresa}`,
      )
    return result
  },
  getChecklist: async (idComponente: number, ID: number) => {
    const result: AxiosResponse<ServiceListResponse<ICheckList>> =
      await ApiService({ idComponente }).get<ServiceListResponse<ICheckList>>(
        `${hosts.WS_DOCAS}/checklist/${ID}`,
      )
    return result
  },
  saveChecklist: async (idComponente: number, ID: number, values: any) => {
    const result: AxiosResponse<ServiceListResponse<ICheckList>> =
      await ApiService({ idComponente }).get<ServiceListResponse<ICheckList>>(
        `${hosts.WS_DOCAS}/checklist/${ID}`,
      )
    return result
  },
}

export default checklist
